<template>
  <main-content class="e-registration-public-term-cond-view">
    <b-card class="e-registration-public-term-cond-view__content">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
          <ERegistrationPublicTermCond v-model="accepted" />

          <b-button type="submit" variant="primary">
            {{ $t("accept") }}
          </b-button>
        </b-form>
      </validation-observer>
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationPublicTermCond from "../components/ERegistrationPublicTermCond";

export default {
  components: {
    ERegistrationPublicTermCond
  },
  data() {
    return {
      accepted: false
    };
  },
  methods: {
    onSubmit() {
      this.$router.push({ name: "ERegistrationPublicRegister" });
    }
  }
};
</script>

<style lang="scss" scoped>
.e-registration-public-term-cond-view {
  &__content {
    position: relative;
    width: 100%;
    top: 15%;
  }
}
</style>

<i18n src="@/locales/actions.locale.json"></i18n>
